export const parseLocalDate = (data) => {
  if (!data) return null;
  if (data instanceof Date) return data;

  const [somenteData] = String(data).split('T');
  const [ano, mes, dia] = somenteData.split('-').map(Number);

  if (!ano || !mes || !dia) return new Date(data);

  return new Date(ano, mes - 1, dia);
};

export const formatarDataBR = (data) => {
  const dataObj = parseLocalDate(data);
  return dataObj ? dataObj.toLocaleDateString('pt-BR') : '';
};

export const formatarData = (data) => {
  const dataObj = new Date(data);

  const ano = dataObj.getFullYear();
  const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
  const dia = String(dataObj.getDate()).padStart(2, '0');

  const dataFormatada = `${ano}-${mes}-${dia}`;
  return dataFormatada;
};
